export default __webpack_public_path__ + "static/ep-0-card-cccd97ab4d76b2ffa0975763dfd1e3bb.png";